(ns ui.view.counterparty-diligence.send-to-responders-modal.event
  (:require
   [frontend.controller.websocket.event :as ws]
   [potpuri.core :as p]
   [re-frame.core :as rf]
   [ui.view.counterparty-diligence.send-to-responders-modal.model :as model]))

(rf/reg-event-db
 ::clear-state-and-close-modal
 (fn [db]
   (p/dissoc-in db model/root-path)))

(rf/reg-event-db
 ::open-modal
 [rf/trim-v]
 (fn [db [{:keys [_counterparty-diligence]}]]
   (let [email-subject (model/default-email-subject)
         email-body (model/default-email-body)]
     (-> db
         (assoc-in model/modal-open-full-path true)
         (assoc-in model/new-responders-full-path [])
         (assoc-in model/email-subject-full-path email-subject)
         (assoc-in model/email-body-full-path email-body)))))

(rf/reg-event-db
 ::set-new-responders
 [rf/trim-v]
 (fn [db [new-responders]]
   (assoc-in db model/new-responders-full-path new-responders)))

(rf/reg-event-db
 ::set-email-subject
 [rf/trim-v]
 (fn [db [email-subject]]
   (assoc-in db model/email-subject-full-path email-subject)))

(rf/reg-event-db
 ::set-email-body
 [rf/trim-v]
 (fn [db [email-body]]
   (assoc-in db model/email-body-full-path email-body)))

(rf/reg-event-fx
 ::add-and-invite-responders-success
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [on-success-event]} resp]]
   (merge
    {:db (p/dissoc-in db model/root-path)}
    (when (vector? on-success-event)
      {:fx [[:dispatch (conj on-success-event resp)]]}))))

(rf/reg-event-fx
 ::add-and-invite-responders-error
 [rf/trim-v]
 (fn [{:keys [db]} [_args resp]]
   (js/console.log "Add and invite responders error " resp)
   {:db (assoc-in db model/submitting-full-path false)}))

(rf/reg-event-fx
 ::add-and-invite-responders
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [process] :as args}]]
   (let [process-id (:db/id process)
         new-responder-ids (->> (get-in db model/new-responders-full-path)
                                (mapv :value))
         email-subject (get-in db model/email-subject-full-path)
         email-body (get-in db model/email-body-full-path)]
     {:db       (assoc-in db model/submitting-full-path true)
      ::ws/send {:id         :counterparty-diligence-process/add-and-invite-responders
                 :body       {:process-id    process-id
                              :responder-ids new-responder-ids
                              :email-subject email-subject
                              :email-body    email-body}
                 :on-success [::add-and-invite-responders-success args]
                 :on-error   [::add-and-invite-responders-error args]}})))

(rf/reg-event-fx
 ::remove-responders-success
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [responder-ids-to-remove refetch-data-event]}]]
   (let [prev-removing-responders (get-in db model/removing-responders-full-path {})
         _new-removing-responders (apply dissoc prev-removing-responders responder-ids-to-remove)]
     (when (vector? refetch-data-event)
       {:fx [[:dispatch refetch-data-event]]}))))

(rf/reg-event-fx
 ::remove-responders-error
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [responder-ids-to-remove]}]]
   (let [prev-removing-responders (get-in db model/removing-responders-full-path {})
         new-removing-responders (apply dissoc prev-removing-responders responder-ids-to-remove)]
     {:db (assoc-in db model/removing-responders-full-path new-removing-responders)})))

(rf/reg-event-fx
 ::remove-responders
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [process responder-ids-to-remove] :as args}]]
   (let [process-id (:db/id process)
         prev-removing-responders (get-in db model/removing-responders-full-path {})
         new-removing-responders (merge prev-removing-responders
                                        (->> responder-ids-to-remove
                                             (mapv (fn [id]
                                                     [id true]))
                                             (into {})))]
     {:db       (assoc-in db model/removing-responders-full-path new-removing-responders)
      ::ws/send {:id         :counterparty-diligence-process/remove-responders
                 :body       {:process-id              process-id
                              :responder-ids-to-remove responder-ids-to-remove}
                 :on-success [::remove-responders-success args]
                 :on-error   [::remove-responders-error args]}})))


